"use client"

import { useEffect, useState } from "react"
import { Box, Typography, Paper, Button, CircularProgress } from "@mui/material"
import { CheckCircleOutline, ErrorOutline, InfoOutlined } from "@mui/icons-material" // আইকন ইম্পোর্ট করা হয়েছে
import { useSearchParams, Link, useNavigate } from "react-router-dom" // useNavigate ইম্পোর্ট করা হয়েছে

const EmailVerified = () => {
  const [params] = useSearchParams()
  const status = params.get("status") // URL থেকে status প্যারামিটার নেওয়া হচ্ছে
  const navigate = useNavigate()
  const [message, setMessage] = useState("")
  const [icon, setIcon] = useState(null)
  const [iconColor, setIconColor] = useState("primary.main")
  const [loading, setLoading] = useState(true) // লোডিং স্টেট যোগ করা হয়েছে

  useEffect(() => {
    let displayMessage = ""
    let displayIcon = null
    let displayColor = "primary.main"

    switch (status) {
      case "success":
        displayMessage = "Email verified successfully! You can now log in."
        displayIcon = <CheckCircleOutline />
        displayColor = "success.main"
        break
      case "already_verified":
        displayMessage = "Email was already verified. You can now log in."
        displayIcon = <InfoOutlined />
        displayColor = "info.main"
        break
      case "invalid":
        displayMessage = "Invalid verification link. Please try again or register."
        displayIcon = <ErrorOutline />
        displayColor = "error.main"
        break
      case "not_found":
        displayMessage = "User not found for this verification link."
        displayIcon = <ErrorOutline />
        displayColor = "error.main"
        break
      default:
        displayMessage = "Something went wrong with the verification process."
        displayIcon = <ErrorOutline />
        displayColor = "error.main"
    }

    setMessage(displayMessage)
    setIcon(displayIcon)
    setIconColor(displayColor)
    setLoading(false) // লোডিং শেষ

    // সফল হলে 3 সেকেন্ড পর লগইন পেজে রিডাইরেক্ট
    if (status === "success" || status === "already_verified") {
      setTimeout(() => {
        navigate("/login")
      }, 3000)
    }
  }, [status, navigate]) // status বা navigate পরিবর্তিত হলে useEffect আবার চলবে

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundColor: "#f5f5f5",
        }}
      >
        <CircularProgress />
        <Typography variant="h6" sx={{ ml: 2 }}>
          Verifying email...
        </Typography>
      </Box>
    )
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
      }}
    >
      <Paper elevation={3} sx={{ p: 4, maxWidth: 400, width: "100%", borderRadius: 2, textAlign: "center" }}>
        {icon && <Box sx={{ fontSize: 80, color: iconColor, mb: 2 }}>{icon}</Box>}
        <Typography variant="h5" component="h1" gutterBottom sx={{ mb: 2, fontWeight: "bold" }}>
          Email Verification Status
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {message}
        </Typography>
        {(status === "invalid" || status === "not_found" || !status) && (
          <Link to="/login" style={{ textDecoration: "none" }}>
            <Button variant="contained" fullWidth sx={{ py: 1.5 }}>
              Go to Login
            </Button>
          </Link>
        )}
      </Paper>
    </Box>
  )
}

export default EmailVerified
